import { render, staticRenderFns } from "./Specific_m.vue?vue&type=template&id=e9bd563e&scoped=true&"
import script from "./Specific_m.vue?vue&type=script&lang=js&"
export * from "./Specific_m.vue?vue&type=script&lang=js&"
import style0 from "./Specific_m.vue?vue&type=style&index=0&id=e9bd563e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bd563e",
  null
  
)

export default component.exports